var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                { ref: "form", staticClass: "col-md-12" },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Asociar Eventos" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c(
                                "v-expansion-panel",
                                _vm._l(this.lstRutas, function(item) {
                                  return _c(
                                    "v-expansion-panel-content",
                                    {
                                      key: item.zona,
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "header",
                                            fn: function() {
                                              return [
                                                _c("div", [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(item.nombre) +
                                                        " > " +
                                                        _vm._s(item.zonaNombre)
                                                    )
                                                  ])
                                                ])
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c(
                                        "v-card",
                                        { staticClass: "grey lighten-4" },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: { row: "", wrap: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs12: "" } },
                                                    [
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          attrs: {
                                                            row: "",
                                                            wrap: ""
                                                          }
                                                        },
                                                        _vm._l(
                                                          item.lstTipoEventoCopiloto,
                                                          function(itemEvent) {
                                                            return _c(
                                                              "v-flex",
                                                              {
                                                                key:
                                                                  itemEvent.id,
                                                                attrs: {
                                                                  xs3: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-card-text",
                                                                  [
                                                                    _c(
                                                                      "v-checkbox",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            itemEvent.nombre,
                                                                          "v-model":
                                                                            itemEvent.selected,
                                                                          value:
                                                                            itemEvent.id,
                                                                          disabled:
                                                                            _vm.isVerDetalle
                                                                        },
                                                                        on: {
                                                                          change: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.handleSelectItem(
                                                                              $event,
                                                                              itemEvent,
                                                                              item
                                                                            )
                                                                          }
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }